var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.272.021C4.286-.17 4.95.973 5.456 1.761c.492.766 1.097 1.664.853 2.661-.136.56-.642.864-1.024 1.194-.377.326-.951.625-1.09 1.125-.228.812.27 1.664.578 2.15A12.347 12.347 0 007.4 11.858c.523.428 1.25 1 1.978.853 1.087-.22 1.374-1.56 2.558-1.74 1.127-.17 1.89.647 2.526 1.194.613.53 1.602 1.209 1.535 2.116-.04.522-.458.845-.82 1.16-.37.321-.692.682-1.057.92-.882.576-1.965.858-3.207.82-1.219-.038-2.19-.452-3.07-.921-1.722-.919-3.083-2.211-4.366-3.651-1.26-1.416-2.425-3.092-3.07-4.945C-.395 5.35.03 2.973 1.33 1.49c.22-.252.568-.515.886-.785.318-.271.612-.6 1.057-.684z"
  })));
}

export default SvgPhone;